import React from 'react';
import { Button } from 'antd';
import USFaxNumberInput from 'components/form/USFaxNumberInput';
import s from './s.module.less';
import ps from '../../s.module.less';

type Props = {
    onBack: () => void;
    onContinue: (number: string) => void;
};

const EnterNumber = ({ onBack, onContinue }: Props) => {
    const [phoneNumber, setPhoneNumber] = React.useState('');

    const digits = phoneNumber.replaceAll(/\D/g, '');
    // USFaxNumberInput emits digits only (max 10). We submit E.164 for backend.
    const isValid = digits.length === 10;
    const submitNumber = isValid ? `+1${digits}` : phoneNumber;

    return (
        <>
            <button type="button" className={ps.backLink} onClick={onBack}>
                <span className={ps.backIcon}>‹</span>
                <span>Back</span>
            </button>
            <div className={ps.header}>
                <div className={ps.headerTitle}>Transfer an existing fax number</div>
            </div>
            <div className={s.section}>
                <div className={s.sectionTitle}>Check number portability</div>
                <div className={s.sectionDesc}>
                    Enter or paste your number. Numbers must include the country code. (Maximum of 1,000 numbers per port)
                </div>
                <div className={s.inputWrap}>
                    <USFaxNumberInput
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        placeholder="e.g. (201) 555-1234"
                        size="large"
                        needDisplay
                    />
                </div>
            </div>
            <Button
                type="primary"
                className={ps.actionBtn}
                disabled={!isValid}
                onClick={() => onContinue(submitNumber)}
            >
                Continue
            </Button>
        </>
    );
};

export default EnterNumber;
